import type { ComponentConfigV2 } from '@/types/configurationV2'
import { resolveWarmupPolicy, WARMUP_POLICY_MODE_LABELS, type WarmupRound } from './warmupPolicy'

const ROUND_LABELS: Record<WarmupRound, string> = {
  initial: '첫 학습',
  designatedReview: '복습',
}

const MODE_CLASSES: Record<string, string> = {
  hidden: 'bg-gray-100 text-gray-500',
  required: 'bg-blue-50 text-blue-700',
  optional: 'bg-amber-50 text-amber-700',
}

/** 생각열기 카드 헤더 — 회차별(첫 학습/복습) 유효 정책 요약. 정책 미설정이면 기존 설정 해석임을 함께 표시. */
export function WarmupRoundBadges({ component }: { component: ComponentConfigV2 }) {
  const rounds: WarmupRound[] = ['initial', 'designatedReview']
  const explicit = component.warmupPolicy != null
  return (
    <div className="mt-1 flex flex-wrap items-center gap-1" data-testid="warmup-round-badges">
      {rounds.map((round) => {
        const resolved = resolveWarmupPolicy(component, round)
        return (
          <span
            key={round}
            className={`inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[11px] font-medium ${MODE_CLASSES[resolved.mode]}`}
          >
            <span className="text-gray-500">{ROUND_LABELS[round]}:</span>
            {WARMUP_POLICY_MODE_LABELS[resolved.mode]}
          </span>
        )
      })}
      {!explicit && <span className="text-[11px] text-gray-400">(기존 설정 해석)</span>}
    </div>
  )
}
